
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'AgeLimit7'
})
export default class AgeLimit7 extends Vue {}
